<template>
  <div>
    <vx-card v-if="showImportWidget">
      <div class="text-center pb-8">
        <h4 class="pb-2">You Are importing contacts directly to master database</h4>
        <p class="text-dark-grey">
          This will upload your contact from the submitted document to the
          database.
        </p>
      </div>
      <div class="mb-8">
        <import-excel :onSuccess="loadDataInTable" :purpose="'import_contacts'" @created-csv-filename="getCsvFileName"/>
      </div>
    </vx-card>
    <vx-card
      title="Now you need to match fields to import contacts."
      class="mt-5"
      v-if="showFieldComparision"
    >
      <p>
        On the left are the fields from our database. On the right are the
        fields from the file you have uploaded. The matched fields will upload
        data to the specific field on the database.
      </p>

      <!-- <vs-progress  color="primary"></vs-progress>
      <p class="text-center mt-5">
        Please Wait Your Field Matching and Data is Being Processed
      </p> -->
      <div class="vx-row p-10">
        <div class="vx-col w-full md:w-1/3">
          <vs-list>
            <vs-list-header
              title="Database Fields"
              color="primary"
            ></vs-list-header>
            <template v-for="(slot, index) in fieldgroups">
              <div class="vx-row" :key="index">
                <div class="vx-col w-full md:w-4/5">
                  <v-select
                    class="pb-10 pt-10"
                    :options="list1"
                    v-model="slot.dbfield"
                  />
                </div>
                <div class="vx-col w-full md:w-1/5">
                  <vs-icon size="18px" 
                  class="cursor-pointer mt-3"
                  @click="deleteColumn(slot)"
                  color="danger"
                  icon="delete"
                  :key="index + 1"
                ></vs-icon>
                </div>
              </div>
            </template>
            <p class="mb-3" style="color:red;" v-if="validation_message">
              {{ validation_message }}
            </p>
          </vs-list>
          <vs-button
            color="danger"
            icon-pack="feather"
            icon="icon-plus"
            @click="addAnother"
            >Add another column</vs-button
          >
        </div>
        <div class="vx-col w-full md:w-1/3">
          <vs-list>
            <vs-list-header
              title="Uploaded Fields"
              color="primary"
            ></vs-list-header>
            <template v-for="(slot, index) in fieldgroups">
              <v-select
                :closeOnSelect="true"
                class="pb-10 pt-10"
                :options="list2"
                :key="index"
                v-model="slot.uploadfield"
              />
            </template>
          </vs-list>
        </div>
        <div class="vx-col w-full md:w-1/3">
          <p>Note :</p>
          <p class="text-dark-grey">
            1. Fields should not be empty.
          </p>
          <div class="p-10">
            <vs-button
              @click="upload()"
              color="primary"
              type="filled"
              style="float:right;"
              >Upload</vs-button
            >
          </div>
        </div>
      </div>
    </vx-card>
    <vs-popup
      title="Account does not exists.Please correct fields and upload again"
      :active.sync="popupActive"
    >
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Company Registration No.</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="title" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Country</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            class="w-full"
            @click="editCountry"
            v-show="showCountryField"
            v-model="country"
          />
          <AccountAutocomplete
            ref="autoComplete"
            v-show="showAutocomplete"
            :key="AutocompleteComponentKey"
            class="searchbox"
            :list="getCountries"
            :searchOn="'head_office_country'"
          ></AccountAutocomplete>
          <p class="p-2" style="color:red;" v-if="incorrect_country_validation">
            {{ incorrect_country_validation }}
          </p>
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_company')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Company Name</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="company_name" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_switchboard')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Switchboard</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="job_title" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_status')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Status</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="status" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_linkedin')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Social Media</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="social_media" />
        </div>
      </div>
      <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_web')">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Website</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="email" />
        </div>
      </div>
      <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_phone')">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Phone Number</span>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-input class="w-full" v-model="phone_no" />
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-input class="w-full" v-model="phone_type" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_sic_code')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Sic Code</span>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-input class="w-full" v-model="sic_code" />
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-input class="w-full" v-model="sic_code_description" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_company_category')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Company Category</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="company_category" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_head_office_address_1')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Head Office Address 1</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="head_office_address_1" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_head_office_address_2')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Head Office Address 2</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="head_office_address_2" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_head_office_address_3')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Head Office Address 3</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="head_office_address_3" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_head_office_city')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Head Office City</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="head_office_city" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_head_office_county')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Head Office County</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="head_office_county" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_head_office_postcode')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Head Office Postcode</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="head_office_postcode" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_registered_office_address_1')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Registerd Office address 1</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="registered_office_address_1" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_registered_office_address_2')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Registerd Office address 2</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="registered_office_address_2" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_registered_office_address_3')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Registerd Office address 3</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="registered_office_address_3" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_registered_office_city')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Registerd Office city</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="registered_office_city" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_registered_office_county')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Registerd Office county</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="registered_office_county" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_registered_office_postcode')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Registerd Office postcode</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="registered_office_postcode" />
        </div>
      </div>
      <div
        class="vx-row mb-6"
        v-if="field_array_columns.includes('enh_registered_office_country')"
      >
        <div class="vx-col sm:w-1/3 w-full">
          <span>Registerd Office country</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="registered_office_country" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Is new account?</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-checkbox v-model="isNewAccount" vs-value="Y"></vs-checkbox>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-2/3 w-full ml-auto">
          <vs-button @click="submitUpdate()" class="mr-3 mb-2"
            >Submit</vs-button
          >
        </div>
      </div>
    </vs-popup>
    <vx-card v-if="uploadCompleted">
      <h5 class="mb-5">
        Company Registration Number or Country have been mistaken. Please update
        and click on the finished button to upload it again.
      </h5>
      <vs-table stripe :data="notExisted">
        <template slot="thead">
          <vs-th>Company Registration Number</vs-th>
          <vs-th>Country</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].enh_company_registration_number">
              {{ data[indextr].enh_company_registration_number }}
            </vs-td>
            <vs-td :data="data[indextr].enh_country">
              {{ data[indextr].enh_country }}
            </vs-td>
            <vs-td>
              <vs-button
                color="primary"
                @click="updateRegOrCountry(data[indextr])"
                type="border"
                >Update</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="flex flex-wrap items-center justify-end mt-5">
        <vs-button @click="finished()" color="primary" type="border"
          >Finished</vs-button
        >
      </div>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import ImportExcel from "@/components/excel/ImportExcel.vue";
import vSelect from "vue-select";
import axios from "@/axios.js";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
export default {
  components: {
    ImportExcel,
    vSelect,
    AccountAutocomplete
  },
  data() {
    return {
                              abilities : null,

      field_array_columns: [],
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      company_category: null,
      sic_code: null,
      sic_code_description: null,
      phone_type: null,
      phone_no: null,
      email: null,
      social_media: null,
      status: null,
      job_title: null,
      company_name: null,
      selected_fields: null,
      incorrect_country_validation: null,
      showCountryField: true,
      showAutocomplete: false,
      AutocompleteComponentKey: 0,
      title: null,
      country: null,
      isNewAccount: null,
      update_id: null,
      table: null,
      popupActive: false,
      uploadCompleted: false,
      notExisted: [],
      validation_message: "",
      fieldgroups: [
        {
          dbfield: "",
          count: 0,
          uploadfield: [],
          selection: true
        }
      ],
      allSelected: false,
      selected: [],
      count: 0,
      showFieldComparision: false,
      showImportWidget: true,
      tableData: [],
      header: [],
      sheetName: "",
      list2: [],
      uploaded_columns: [],
      accept_text: "Accept",
      acceptButtonColor: "primary",
      list1: [
        {
          id: 1,
          name: "company",
          value: "company",
          label: "Company",
          selection: true
        },
        {
          id: 2,
          name: "title",
          value: "title",
          label: "Title",
          selection: true
        },
        {
          id: 3,
          name: "forename",
          value: "forename",
          label: "Forename",
          selection: true
        },
        {
          id: 4,
          name: "surname",
          value: "surname",
          label: "Surname",
          selection: true
        },
        {
          id: 5,
          name: "job_title",
          value: "job_title",
          selection: true,
          label: "Job Title"
        },
        {
          id: 6,
          name: "email",
          value: "email",
          selection: true,
          label: "Email"
        },
        {
          id: 7,
          name: "ddi",
          value: "ddi",
          selection: true,
          label: "DDI"
        },
        {
          id: 8,
          name: "mobile",
          value: "mobile",
          selection: true,
          label: "Mobile"
        },
        {
          id: 9,
          name: "social_media",
          value: "social_media",
          selection: true,
          label: "Social Media"
        },
        {
          id: 10,
          name: "role",
          value: "role",
          selection: true,
          label: "Role"
        },
        {
          id: 11,
          name: "sub_role",
          value: "sub_role",
          selection: true,
          label: "Sub Role"
        },
        {
          id: 12,
          name: "seniority",
          value: "seniority",
          selection: true,
          label: "Seniority"
        }
      ]
    };
  },
  mounted() {
    // console.log(this.selected)
  },
  watch: {},
  methods: {
    editCountry() {
      this.showCountryField = false;
      this.showAutocomplete = true;
      this.$refs.autoComplete.$refs.suggestComponent.isInFocus = true;
      this.$refs.autoComplete.$refs.suggestComponent.isClicking = true;
      this.$refs.autoComplete.$refs.suggestComponent.input.value = this.country;
      this.$refs.autoComplete.$refs.suggestComponent.value = this.country;
    },
    upload() {
      // this.$vs.loading();
      axios
        .post(
          this.$base_url + "/api/contacts/upload_data_master_database",
          this.fieldgroups
        )
        .then(response => {
          if (response.data.status == "success") {
          // this.$vs.loading.close();
        }})
        .catch(error => {
          console.log(error);
        });
    },
    getCsvFileName(value){
       // alert(value)
    },
    updateRegOrCountry(data) {
      if (data.new_account == "Y") {
        this.isNewAccount = "Y";
      } else {
        this.isNewAccount = null;
      }
      this.selected_fields = data.fields;
      this.incorrect_country_validation = null;
      this.AutocompleteComponentKey += 1;
      this.popupActive = true;
      this.title = data.enh_company_registration_number;
      this.country = data.enh_country;
      this.company_name = data.enh_company;
      this.job_title = data.enh_switchboard;
      this.status = data.enh_status;
      this.social_media = data.enh_linkedin;
      this.email = data.enh_web;
      this.phone_no = data.enh_phone;
      this.phone_type = data.enh_phone_type;
      this.sic_code = data.enh_sic_code;
      this.sic_code_description = data.enh_sic_code_description;
      this.company_category = data.enh_company_category;
      this.head_office_address_1 = data.enh_head_office_address_1;
      this.head_office_address_2 = data.enh_head_office_address_2;
      this.head_office_address_3 = data.enh_head_office_address_3;
      this.head_office_city = data.enh_head_office_city;
      this.head_office_county = data.enh_head_office_county;
      this.head_office_postcode = data.enh_head_office_postcode;
      this.registered_office_address_1 = data.enh_registered_office_address_1;
      this.registered_office_address_2 = data.enh_registered_office_address_2;
      this.registered_office_address_3 = data.enh_registered_office_address_3;
      this.registered_office_city = data.enh_registered_office_city;
      this.registered_office_county = data.enh_registered_office_county;
      this.registered_office_postcode = data.enh_registered_office_postcode;
      this.registered_office_country = data.enh_registered_office_country;
      this.update_id = data.enh_id;
      this.table = data.table;
      this.showCountryField = true;
      this.showAutocomplete = false;
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          if (response) {
            let data = moduleAccountsManagement.state.countries;
            let mappedArray = [];
            for (const property in data) {
              mappedArray.push({
                id: data[property].id,
                name: data[property].name_1
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    submitUpdate() {
      let updateData = {fieldValues:{}};
      updateData.id = this.update_id;
      updateData.title = this.title;
      updateData.country = this.country;
      updateData.isNewAccount = this.isNewAccount;
      updateData.fields = this.selected_fields;
      updateData.fieldValues.enh_company = this.company_name;
      updateData.fieldValues.enh_switchboard = this.job_title;
      updateData.fieldValues.enh_status = this.status;
      updateData.fieldValues.enh_social_media = this.social_media;
      updateData.fieldValues.enh_website = this.email;
      updateData.fieldValues.enh_phone_no = this.phone_no;
      updateData.fieldValues.enh_phone_type = this.phone_type;
      updateData.fieldValues.enh_sic_code = this.sic_code;
      updateData.fieldValues.enh_sic_code_description = this.sic_code_description;
      updateData.fieldValues.enh_company_category = this.company_category;
      updateData.fieldValues.enh_head_office_address_1 = this.head_office_address_1;
      updateData.fieldValues.enh_head_office_address_2 = this.head_office_address_2;
      updateData.fieldValues.enh_head_office_address_3 = this.head_office_address_3;
      updateData.fieldValues.enh_head_office_city = this.head_office_city;
      updateData.fieldValues.enh_head_office_county = this.head_office_county;
      updateData.fieldValues.enh_head_office_postcode = this.head_office_postcode;
      updateData.fieldValues.enh_registered_office_address_1 = this.registered_office_address_1;
      updateData.fieldValues.enh_registered_office_address_2 = this.registered_office_address_2;
      updateData.fieldValues.enh_registered_office_address_3 = this.registered_office_address_3;
      updateData.fieldValues.enh_registered_office_city = this.registered_office_city;
      updateData.fieldValues.enh_registered_office_county = this.registered_office_county;
      updateData.fieldValues.enh_registered_office_postcode = this.registered_office_postcode;
      updateData.fieldValues.enh_registered_office_country = this.registered_office_country;
      this.country = moduleAccountsManagement.head_office_country_selected.name
      if (moduleAccountsManagement.head_office_country_selected === undefined) {
        this.incorrect_country_validation =
          "Country is Incorrect. Please update and submit again";
        return false;
      }
      this.country = moduleAccountsManagement.head_office_country_selected.name;
      updateData.country = this.country;
      // moduleAccountsManagement.head_office_country_selected = {}
      updateData.table = this.table;
      console.log(updateData)
      console.log("==================================")
      // this.$vs.loading();
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/update_reg_or_country",
          updateData
        )
        .then(response => {
          if (response.data.status == "success") {
            this.popupActive = false;
            this.notExisted = response.data.data;
          }
          if (response.data.status == "completed") {
            this.popupActive = false;
            this.$vs.notify({
              color: "success",
              title: "Enhanced Account",
              text: "The document has been enhanced to accounts"
            });
            this.fieldgroups = [
              {
                dbfield: "",
                count: 0,
                uploadfield: [],
                selection: true
              }
            ];
            this.uploadCompleted = false;
            this.showImportWidget = true;
          }
          if (response.data.status == "title_exists") {
            this.popupActive = false;
            this.$vs.dialog({
              color: "primary",
              title: `Duplicate Company Registration Number`,
              text:
                "Company registration number already exists in the database.Please update it and submit again",
              accept: this.acceptAlert
            });
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    acceptAlert() {
      this.popupActive = true;
    },
    finished() {
      let tableData = {};
      tableData.table_name = this.table;
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/finish_enhance",
          tableData
        )
        .then(response => {
          if (response.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Enhanced Account",
              text: "The document has been enhanced to accounts"
            });
            this.fieldgroups = [
              {
                dbfield: "",
                count: 0,
                uploadfield: [],
                selection: true
              }
            ];
            this.uploadCompleted = false;
            this.showImportWidget = true;
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    addAnother: function() {
      this.fieldgroups.push({
        dbfield: "",
        uploadfield: [],
        count: ++this.count
      });
    },
    deleteColumn(slot) {
      console.log(this.fieldgroups);
      this.fieldgroups = this.fieldgroups.filter(function(ele) {
        return ele != slot;
      });
      console.log(slot);
      // this.fieldgroups.pop(slot);
    },
    loadDataInTable({ header }) {
      // console.log(header);
      header.map(function(el) {
        var o = Object.assign({}, el);
        o.name = el;
        return o;
      });
      this.list2 = header;
      this.showImportWidget = false;
      this.showFieldComparision = true;
      this.$vs.loading.close();
    }
  },
  created(){
        var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
</style>
